import React from 'react';
import AuthGateModal from './AuthGateModal';
import ProfileCompletionModal from './ProfileCompletionModal';

/**
 * Convenience wrapper that mounts BOTH the auth gate (logged-out users)
 * and the profile-completion gate (logged-in but no phone yet) for a
 * useBookingFlow() instance. Drop-in replacement for the previous
 * standalone <AuthGateModal> import in every booking call-site.
 *
 * Why a wrapper rather than mounting these inside useBookingFlow itself?
 * Hooks can't return JSX directly; making each booking-aware component
 * mount the same two-line snippet would be repetitive. This wrapper
 * keeps the public API tiny: `<BookingGateModals booking={booking} />`.
 */
export default function BookingGateModals({ booking }) {
  return (
    <>
      <AuthGateModal isOpen={booking.authGateOpen} onClose={booking.closeAuthGate} />
      <ProfileCompletionModal
        isOpen={booking.profileGateOpen}
        onClose={booking.closeProfileGate}
        onComplete={booking.onProfileComplete}
      />
    </>
  );
}
